import React, { useState } from "react";
import AppLayout from "@amzn/awsui-components-react/polaris/app-layout";
import DarkModeContext from "../../contexes/DarkModeContext";
import PageHeader from "../PageHeader";
import ChatUatPage from "./ChatUatPage";

export const ChatUatPortal: React.FC = () => {
  const [darkMode, setDarkMode] = useState(false);

  return (
    <DarkModeContext.Provider value={darkMode}>
      <PageHeader setDarkMode={setDarkMode} />
      <AppLayout
        contentType="default"
        headerSelector="#h"
        maxContentWidth={1700}
        navigationHide
        toolsHide
        content={<ChatUatPage />}
      />
    </DarkModeContext.Provider>
  );
};
